if (!customElements.get('promo-video')) {
  customElements.define(
    'promo-video',
    class PromoVideo extends HTMLElement {
      connectedCallback() {
        if (this.isInitialized) return;

        this.videos = Array.from(this.querySelectorAll('video'));
        this.button = this.querySelector('[data-video-playback-button]');
        this.playIcon = this.querySelector('[data-video-play-icon]');
        this.pauseIcon = this.querySelector('[data-video-pause-icon]');
        this.mobileMediaQuery = window.matchMedia('(max-width: 749px)');
        this.reducedMotionMediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

        if (!this.videos.length) return;

        this.isInitialized = true;
        this.handleBreakpointChange = () => this.syncActiveVideo();
        this.mobileMediaQuery.addEventListener('change', this.handleBreakpointChange);

        if (this.button) {
          this.button.addEventListener('click', () => this.togglePlayback());
          this.videos.forEach((video) => {
            video.addEventListener('play', () => this.updatePlaybackButton());
            video.addEventListener('pause', () => this.updatePlaybackButton());
          });
        }


        this.syncActiveVideo();
      }

      disconnectedCallback() {
        this.mobileMediaQuery?.removeEventListener('change', this.handleBreakpointChange);
      }

      getActiveVideo() {
        if (this.mobileMediaQuery.matches) {
          return this.querySelector('.video-banner__video--mobile') || this.querySelector('.video-banner__video--desktop');
        }

        return this.querySelector('.video-banner__video--desktop') || this.querySelector('.video-banner__video--mobile');
      }

      syncActiveVideo() {
        const activeVideo = this.getActiveVideo();
        const shouldPlay = !this.reducedMotionMediaQuery.matches && (!this.video || !this.video.paused);

        this.videos.forEach((video) => {
          if (video !== activeVideo) video.pause();
        });

        this.video = activeVideo;

        if (shouldPlay) {
          this.video.play().catch(() => {});
        } else {
          this.video.pause();
        }

        this.updatePlaybackButton();
      }

      togglePlayback() {
        if (this.video.paused) {
          this.video.play().catch(() => {});
        } else {
          this.video.pause();
        }
      }

      updatePlaybackButton() {
        if (!this.button || !this.video) return;

        const isPaused = this.video.paused;
        this.playIcon.hidden = !isPaused;
        this.pauseIcon.hidden = isPaused;
        this.button.setAttribute('aria-pressed', isPaused ? 'false' : 'true');
      }
    }
  );
}
